<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";

    const dispatcher = createEventDispatcher();

    export let value;
    export let placeHolder = '';
    export let widthEm = null;
    export let isShowClear = false;

    $: style = (() => {
        const styleArray = [];

        if (widthEm != null) {
            styleArray.push(`width: ${widthEm}em`);
        }

        const style = styleArray.join(';');
        return style;
    })();

    $: isShowClearButton = (() => {
        if (!isShowClear) {
            return false;
        }
        if (value == '') {
            return false;
        }

        return true;
    })();


    onMount(() => {
    });

    function onKeyPress(event: KeyboardEvent) {
        dispatcher('keypress', {event: event});

        const key = event.key;
        if (key === 'Enter') {
            dispatcher('enter', {event: event});
        }

    }

    function onClickClear() {
        value = '';
    }

</script>

<span class="input-text-view">
    <input type="text" style={style} bind:value={value} placeholder={placeHolder}
           on:keypress={onKeyPress}
           on:input on:keydown on:change on:click
    />

    {#if isShowClear}
        <span class="clear-button" class:show={isShowClearButton} on:click={onClickClear}>✕</span>
    {/if}

</span>
<style lang="scss">
    .input-text-view {
        position: relative;

        > input {


        }

        .clear-button {
            position: absolute;
            right: 0.5em;
            top: calc(50% - 0.5em);
            display: flex;
            width: 1em;
            height: 1em;
            line-height: 1em;
            align-items: center;
            justify-content: center;

            opacity: 0;
            cursor: pointer;
            transition-duration: 0.25s;
            transform: translateX(100%);

        }

        &:hover {
            .clear-button {
                &.show {
                    opacity: 0.5;
                    transform: translateX(0%);

                }

            }
        }

    }
</style>